import { render } from "./achieveInfo.vue?vue&type=template&id=50ad7e7e&scoped=true"
import script from "./achieveInfo.vue?vue&type=script&lang=js"
export * from "./achieveInfo.vue?vue&type=script&lang=js"

import "./achieveInfo.vue?vue&type=style&index=0&id=50ad7e7e&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ad7e7e"]])

export default __exports__